module.exports = __webpack_public_path__ + "media/images/logo_white-789b5c077ac64c488d57acceae5200e9.png";